// Qualified views: article = 5 s of the body on screen in a visible tab; video = 3 s of real playback (or 90 % of a
// clip shorter than 3 s). The server is the authority (30-min window per viewer × content, bots/admin excluded);
// this module only avoids obvious re-sends inside the same browser.
import { API_BASE } from "@/lib/api";
import { newOpId } from "@/lib/readerEvents";

export const ARTICLE_VIEW_SEC = 5;
export const VIDEO_VIEW_SEC = 3;
export const SHORT_VIDEO_PCT = 0.9;
const WINDOW_MS = 30 * 60 * 1000;

const recently = (key) => {
    try { const t = Number(sessionStorage.getItem(key) || 0); return t && Date.now() - t < WINDOW_MS; } catch { return false; }
};

export function sendQualifiedView(articleId, kind, seconds) {
    if (!articleId) return;
    const key = `qv:${kind}:${articleId}`;
    if (recently(key)) return;
    try { sessionStorage.setItem(key, String(Date.now())); } catch { /* private mode */ }
    const body = JSON.stringify({ op_id: newOpId(), article_id: articleId, kind, seconds: seconds == null ? null : Math.round(seconds * 10) / 10 });
    fetch(`${API_BASE}/public/views`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
}

/** True when a clip has been *really* watched enough to count (pauses, buffering and seeks never add to `watched`). */
export const videoViewQualifies = (watchedSec, durationSec) =>
    watchedSec >= VIDEO_VIEW_SEC || (durationSec > 0 && durationSec < VIDEO_VIEW_SEC && watchedSec >= durationSec * SHORT_VIDEO_PCT);

/** Accumulates time while `el` is on screen AND the tab is visible; fires `onQualified` once after `ARTICLE_VIEW_SEC`. */
export function watchArticleView(el, onQualified) {
    if (!el || typeof IntersectionObserver === "undefined") return () => {};
    let seen = false, acc = 0, last = null, done = false, timer = 0;
    const active = () => seen && document.visibilityState === "visible";
    const tick = () => {
        const now = performance.now();
        if (active()) { if (last != null) acc += (now - last) / 1000; last = now; } else last = null;
        if (!done && acc >= ARTICLE_VIEW_SEC) { done = true; stop(); onQualified(acc); }
    };
    const io = new IntersectionObserver(([e]) => { seen = e.isIntersecting; if (!seen) last = null; }, { threshold: 0.1 });
    io.observe(el);
    const onVis = () => { if (document.visibilityState !== "visible") last = null; };
    document.addEventListener("visibilitychange", onVis);
    timer = window.setInterval(tick, 250);
    function stop() { window.clearInterval(timer); io.disconnect(); document.removeEventListener("visibilitychange", onVis); }
    return stop;
}
